<script>
/**
 * 検索条件設定モーダル
 */
export default {
  name: "ConditionModal",
  components: {},
  data() {
    return {
      enableDialog: false,
      conditions: {
        keyword: null,
        with_undecided_plan_date: false,
      },
    };
  },
  watch: {
    enableDialog(val) {
      if (val) {
        // ダイアログが開いたときの初期化処理があればここに記述
      }
    },

  },
  created() {},
  methods: {
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.$emit('searchCallback', this.conditions)
      this.enableDialog = false;
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.enableDialog = false;
    },
  }
}
</script>

<template>
  <v-dialog
      v-model="enableDialog"
      width="600"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          block
          style="background-color: #dce7eb"
          class="panel-header-color"
        >
          <v-icon class="panel-header-color">
            mdi-magnify
          </v-icon>
          絞り込み検索
        </v-btn>
      </template>
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>絞り込み検索</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="conditions.keyword"
                  label="キーワード"
                  clearable
                  dense
                  hide-details="auto"
                  outlined
                  placeholder="排出事業場、引取場所事業場、運搬元事業場、処分事業場"
                  persistent-placeholder
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="conditions.with_undecided_plan_date"
                  label="回収日未定を含む"
                  dense
                  hide-details="auto"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="searchButtonClickEvent"
          >
            検索
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
